import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PagedListingComponentBase } from 'src/app/shared/components/paged-listing-component-base';
import { BalanceHistoriesService } from '../balance-histories.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { RetailersService } from '../../retailers/retailers.service';
import { ControlItem, TransactionTypesEnum } from 'src/app/models/frontend';
import { ToastrService } from 'ngx-toastr';
import { LoginComponent } from '../../login/login.component';
import { LoginService } from '../../login/login.service';
import { TransactionType } from 'src/app/models/enums';

@Component({
  selector: 'app-create-balance-history',
  templateUrl: './create-balance-history.component.html',
  styleUrls: ['./create-balance-history.component.scss']
})
export class CreateBalanceHistoryComponent {
  loader = false
  errors: string[] | null = [];
  balanceForm: FormGroup
  @ViewChild('modal') modal: ElementRef;
  Retailers:any
  retailerData:ControlItem[]=[]
  transactionType:ControlItem[]=[]

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder,
    public balanceSerivce: BalanceHistoriesService, public router: Router,
    public loginService:LoginService,
    public retailerService: RetailersService,private toastr:ToastrService) {
      this.getRetailers()
      this.transactionType=TransactionTypesEnum
  }
  ngOnInit(): void {
    this.balanceForm = this.fb.group({
      Amount: ['', [Validators.required, Validators.maxLength(100)]],
      Remarks: ['', [Validators.required, Validators.maxLength(100)]],
      RetailerId: [null, [Validators.required]],
      TransactionType: ['', [Validators.required, Validators.maxLength(100)]],
    });

  }

  onSubmit() {
    console.log('Test')
    const Amount = parseFloat(this.balanceForm.value.Amount);
    const RetailerId = parseFloat(this.balanceForm.value.RetailerId);
    const transactionType = parseInt(this.balanceForm.value.TransactionType);
    if (!this.balanceForm.valid) return this.balanceForm.markAllAsTouched();
    this.balanceForm = this.fb.group({
      Amount: Amount,
      Remarks: this.balanceForm.value.Remarks,
      RetailerId: RetailerId,
      // NewBalance: NewBalance,
      isAutoTransaction:true,
      stripeTransactionId:"",
      isTestRecord:true,
      transactionType:transactionType,
      orderItemId:0,
      oldBalance:0
    })
    console.log(this.balanceForm.value)
    this.balanceSerivce.createBalanceHistory(this.balanceForm.value)
      .subscribe({
        next: r => {
          this.toastr.success('Created','Success')
          this.activeModal.close({ refresh: true });
        },
        error:e=>{
          if(this.errors = e.error?.errors || [e.error?.message])
          {
            this.toastr.error('Oops!', e.error.message);
          }
          else{
            this.toastr.error('Oops!', "Something went wrong");

          }
        }
      })

  }
  getRetailers() {
    var request = {
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      Keyword: ""
    }
    this.loader = true
    this.retailerService.GetRetailers(request).subscribe((res: any) => {
      this.Retailers = res.items;
      for(let i=0;i<=this.Retailers.length;i++){
        this.retailerData.push({label:this.Retailers[i].fullName,value:this.Retailers[i].id})
      }
      this.loader = false
    })
  }
  logout() {
    this.loginService.logout();
  }
}
